import React from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button';
import { Popover } from '@mantine/core';
import { useState } from 'react';

interface ConfirmationPopoverProps extends React.PropsWithChildren {
  text: string;
  onSubmit: () => void;

  confirmationLabel?: string;
}

export function ConfirmationPopover({
  text,
  onSubmit,
  confirmationLabel = 'Confirm',
  children,
}: ConfirmationPopoverProps) {
  const [opened, setOpened] = useState(false);

  function handleSubmit() {
    onSubmit();
    setOpened(false);
  }

  return (
    <Popover opened={opened} onDismiss={() => setOpened(false)} zIndex={2000}>
      <Popover.Target>
        <TargetContainer onClick={() => setOpened((o) => !o)}>
          {children}
        </TargetContainer>
      </Popover.Target>
      <Popover.Dropdown>
        <ConfirmationPopoverBody
          text={text}
          confirmationLabel={confirmationLabel}
          onSubmit={handleSubmit}
          onCancel={() => setOpened(false)}
        />
      </Popover.Dropdown>
    </Popover>
  );
}

function ConfirmationPopoverBody({
  text,
  confirmationLabel,
  onSubmit,
  onCancel
}: ConfirmationPopoverProps & {
    onCancel: () => void;
}) {
  return (
    <ConfirmationContainer>
      <span>{text}</span>
      <Footer>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="glow" onClick={onSubmit}>
          {confirmationLabel}
        </Button>
      </Footer>
    </ConfirmationContainer>
  );
}

const TargetContainer = styled.div`
  user-select: none;
`;

const ConfirmationContainer = styled.div`
  max-width: 275px;

  span {
    display: block;
    white-space: normal;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 16px;
`;
